module.exports = __webpack_public_path__ + "static/media/naveen.fd8d210d.jpg";